/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 11H15M9 15H13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 3V3C18.209 3 19.9998 4.79075 19.9998 6.99976V14C19.9998 16.8003 19.9998 18.2004 19.4548 19.27C18.9754 20.2108 18.2105 20.9757 17.2697 21.455C16.2001 22 14.8 22 11.9998 22V22C9.19949 22 7.79936 22 6.7298 21.455C5.78899 20.9757 5.02409 20.2108 4.54472 19.27C3.99976 18.2004 3.99976 16.8003 3.99976 14V7.00024C3.99976 4.79097 5.79073 3 8 3V3M10 5H14C15.1046 5 16 4.10457 16 3V3C16 1.89543 15.1046 1 14 1H10C8.89543 1 8 1.89543 8 3V3C8 4.10457 8.89543 5 10 5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M20 14V7.49991C20 5.01468 17.9853 3 15.5001 3C15.5001 4.10457 14.6047 5 13.5001 5H10.5001C9.39552 5 8.50009 4.10457 8.50009 3C6.01476 3 4 5.01476 4 7.50009V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22C14.8003 22 16.2004 22 17.27 21.455C18.2108 20.9757 18.9757 20.2108 19.455 19.27C20 18.2004 20 16.8003 20 14Z"
				fill="currentColor"
			/>
			<path
				d="M16 3V3C18.209 3 19.9998 4.79075 19.9998 6.99976V14C19.9998 16.8003 19.9998 18.2004 19.4548 19.27C18.9754 20.2108 18.2105 20.9757 17.2697 21.455C16.2001 22 14.8 22 11.9998 22V22C9.19949 22 7.79936 22 6.7298 21.455C5.78899 20.9757 5.02409 20.2108 4.54472 19.27C3.99976 18.2004 3.99976 16.8003 3.99976 14V7.00024C3.99976 4.79097 5.79073 3 8 3V3M9 11H15M9 15H13M10 5H14C15.1046 5 16 4.10457 16 3V3C16 1.89543 15.1046 1 14 1H10C8.89543 1 8 1.89543 8 3V3C8 4.10457 8.89543 5 10 5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.24945 2.25C7.70062 1.04698 8.8507 0.25 10.1355 0.25H13.8635C15.1483 0.25 16.2984 1.04699 16.7495 2.25C18.9585 2.25 20.7493 4.04078 20.7493 6.24982V14.75C20.7493 17.5503 20.7493 18.9504 20.2043 20.02C19.7249 20.9608 18.96 21.7257 18.0192 22.205C16.9497 22.75 15.5495 22.75 12.7493 22.75H11.2493C8.44901 22.75 7.04887 22.75 5.97932 22.205C5.0385 21.7257 4.2736 20.9608 3.79423 20.02C3.24927 18.9504 3.24927 17.5503 3.24927 14.75V6.25018C3.24927 4.04094 5.04021 2.25 7.24945 2.25ZM8.74945 3C8.74945 3.69036 9.30909 4.25 9.99945 4.25H13.9995C14.6898 4.25 15.2495 3.69036 15.2495 3C15.2495 2.30964 14.6898 1.75 13.9995 1.75H9.99945C9.30909 1.75 8.74945 2.30964 8.74945 3ZM8.99951 10.25C8.5853 10.25 8.24951 10.5858 8.24951 11C8.24951 11.4142 8.5853 11.75 8.99951 11.75H14.9995C15.4137 11.75 15.7495 11.4142 15.7495 11C15.7495 10.5858 15.4137 10.25 14.9995 10.25H8.99951ZM8.99951 14.25C8.5853 14.25 8.24951 14.5858 8.24951 15C8.24951 15.4142 8.5853 15.75 8.99951 15.75H12.9995C13.4137 15.75 13.7495 15.4142 13.7495 15C13.7495 14.5858 13.4137 14.25 12.9995 14.25H8.99951Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 3V3C18.2091 3 20 4.79086 20 7V14.0001C20 16.8003 20 18.2004 19.4551 19.2699C18.9757 20.2108 18.2108 20.9757 17.2699 21.4551C16.2004 22 14.8003 22 12.0001 22H11.6562C9.17981 22 7.9416 22 6.97392 21.5711C5.8391 21.0681 4.93196 20.1609 4.42897 19.0261C4.00005 18.0584 4.00007 16.8202 4.00011 14.3438V14.3438L4 14M16 3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3M16 3C16 2.63571 15.9026 2.29417 15.7324 2C15.5568 1.69637 15.3036 1.4432 15 1.26756M8 3V3C5.79086 3 4 4.79086 4 7V9.5V10M8 3C8 1.89543 8.89543 1 10 1H12M9 11H15M9 15H13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16 3V3C18.2091 3 20 4.79086 20 7V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V7C4 4.79086 5.79086 3 8 3V3M16 3V3C16 1.89543 15.1046 1 14 1H10C8.89543 1 8 1.89543 8 3V3M16 3V3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3V3M9 11H15M9 15H13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.2498 2.25C8.44949 2.25 7.04936 2.25 5.9798 2.79497C5.03899 3.27433 4.27409 4.03924 3.79472 4.98005C3.24976 6.04961 3.24976 7.44974 3.24976 10.25V14.75C3.24976 17.5503 3.24976 18.9504 3.79472 20.02C4.27409 20.9608 5.03899 21.7257 5.9798 22.205C7.04936 22.75 8.44949 22.75 11.2498 22.75H12.7498C15.55 22.75 16.9501 22.75 18.0197 22.205C18.9605 21.7257 19.7254 20.9608 20.2048 20.02C20.7498 18.9504 20.7498 17.5503 20.7498 14.75V10.25C20.7498 7.44974 20.7498 6.04961 20.2048 4.98005C19.7254 4.03924 18.9605 3.27433 18.0197 2.79497C16.9501 2.25 15.55 2.25 12.7498 2.25H11.2498Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 0.25C7.89543 0.25 7 1.14543 7 2.25C7 3.35457 7.89543 4.25 9 4.25H15C16.1046 4.25 17 3.35457 17 2.25C17 1.14543 16.1046 0.25 15 0.25H9ZM9 10.25C8.58579 10.25 8.25 10.5858 8.25 11C8.25 11.4142 8.58579 11.75 9 11.75H15C15.4142 11.75 15.75 11.4142 15.75 11C15.75 10.5858 15.4142 10.25 15 10.25H9ZM9 14.25C8.58579 14.25 8.25 14.5858 8.25 15C8.25 15.4142 8.58579 15.75 9 15.75H13C13.4142 15.75 13.75 15.4142 13.75 15C13.75 14.5858 13.4142 14.25 13 14.25H9Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
